import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateEditComment = {
  editComment: { data: null, loading: false, error: null },
};

export const editComment = createAsyncThunk('user/editComment', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/candidates/${data.id}/comment`,
      { comment: data.comment },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerEditComment = {
  [editComment.pending]: (state) => {
    // state.editComment.data = null;
    state.editComment.loading = true;
    state.editComment.error = null;
  },
  [editComment.fulfilled]: (state, action) => {
    state.editComment.loading = false;
    state.editComment.data = action.payload;
    state.editComment.error = null;
  },
  [editComment.rejected]: (state, action) => {
    state.editComment.loading = false;
    state.editComment.error = action.payload;
  },
};
